<app-header></app-header>
<div class="dashboard-container">
  <div class="dashboard">
    <app-alert [alertType]="ALERT.DANGER" [alertMessage]="message"> </app-alert>
    <div class="form-group d-flex align-items-center mb-4">
      <label for="month-select" class="me-3 mb-0 fw-bold"
        >Seleccionar mes:
      </label>
      <input
        type="month"
        id="month-select"
        class="form-control"
        style="max-width: 200px"
        [value]="selectedDate"
        (change)="onMonthChange($event)"
      />
    </div>
    <h3 *ngIf="loading">Cargando panel...</h3>
    <h3 *ngIf="!loading && hasLoaded && !hasStudies">
      No tienes consultas en el mes seleccionado
    </h3>
    <div class="row g-4" [class.d-none]="loading || !hasStudies">
      <div class="col-12 col-lg-6 mb-4">
        <div class="card h-100 bg-light">
          <div class="card-body">
            <div class="chart" #allChartContainer></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-4">
        <div class="card h-100 bg-light">
          <div class="card-body">
            <div class="chart" #chartByUserContainer></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-4">
        <div class="card h-100 bg-light">
          <div class="card-body">
            <div class="chart" #chartByCompanyKindContainer></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-4">
        <div class="card h-100 bg-light">
          <div class="card-body">
            <div class="chart" #chartByDispatchStatusContainer></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
